import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Case, CaseInput } from '../../../core/services/case.model';

@Component({
  selector: 'app-new-case-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './new-case-modal.component.html',
  styleUrl: './new-case-modal.component.scss',
})
export class NewCaseModalComponent {
  @Input() set existing(c: Case | null) {
    if (!c) return;
    this.name.set(c.name === 'Exploration' ? '' : c.name);
    this.age.set(c.age);
    this.state.set(c.state);
    this.premium.set(c.premium);
    this.editingId = c.id;
  }
  @Output() submit = new EventEmitter<CaseInput>();
  @Output() cancel = new EventEmitter<void>();

  editingId: number | null = null;

  name = signal('');
  age = signal<number | null>(null);
  state = signal<string | null>(null);
  premium = signal<number | null>(null);

  readonly states = ['AK','AL','AR','AZ','CA','CO','CT','DC','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY'];

  isValid(): boolean {
    return !!this.name().trim();
  }

  onSubmit() {
    if (!this.isValid()) return;
    this.submit.emit({
      name: this.name().trim(),
      age: this.age(),
      state: this.state(),
      premium: this.premium(),
    });
  }
}
